var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccountTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5002 21.5V18H10.8335V6.33333H8.50016V9.83333H0.333496V0.5H8.50016V4H15.5002V0.5H23.6668V9.83333H15.5002V6.33333H13.1668V15.6667H15.5002V12.1667H23.6668V21.5H15.5002ZM17.8335 7.5H21.3335V2.83333H17.8335V7.5ZM17.8335 19.1667H21.3335V14.5H17.8335V19.1667ZM2.66683 7.5H6.16683V2.83333H2.66683V7.5Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountTree);
export default __webpack_public_path__ + "static/media/icon_account_tree.59319d899bd58a38715ad9e86677bf44.svg";
export { ForwardRef as ReactComponent };